import { Api } from 'models/services/api';
import { ReadCentralKitchensQuery } from 'models/services/graphql';

import { CentralKitchenCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query ReadCentralKitchens($nextToken: String) {
    ${ReadCentralKitchensQuery}
  }
`;

type ResponseData = {
  data: {
    readCentralKitchens: CentralKitchenCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: CentralKitchenCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readCentralKitchens;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
